import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import '../QueuePage.scss'
import PagesControl from '../../../components/library/pages/PagesControl';

const QueueTablePages = ({ queue, onSetOffset }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [lastPage, setLastPage] = useState(-1)

    useEffect(() => {
        var o = Number(queue.offset);
        var totalCount = Number(queue.totalCount);
        var limit = Number(queue.limit);

        if (o >= 0 && totalCount > 0 && limit > 0) {
            if (o > totalCount) {
                setCurrentPage(0);
                onSetOffset(0 * queue.limit);
            } else if (o == totalCount) {
                onSetOffset(((o / limit) - 1) * queue.limit);
            } else {
                setCurrentPage(Math.floor(o / limit))
            }
            setLastPage(Math.ceil(totalCount / limit) - 1)
        }
    }, [queue.offset, queue.totalCount, queue.limit])

    const handleSetPage = (page) => {
        localStorage.setItem("currentPage", page * queue.limit);
        if (page !== currentPage) {
            onSetOffset(page * queue.limit)
        }
    }

    return (
        <div className="columns">
            <div className='column is-12'>
                <div className='page-ctrl'>
                    <PagesControl currentPage={currentPage} maxPage={lastPage} onSetPage={handleSetPage} />
                </div>
            </div>
        </div>
    );
}

QueueTablePages.propTypes = {
    queue: PropTypes.object.isRequired,
    onSetOffset: PropTypes.func.isRequired
}

export default QueueTablePages